const CHUNK_RELOAD_KEY = "baysport_chunk_reload";
const SW_RESET_KEY = "baysport_sw_reset_at";

function isChunkLoadError(reason) {
  const msg = String(reason?.message || reason || "");
  return (
    reason?.name === "ChunkLoadError" ||
    msg.includes("Loading chunk") ||
    msg.includes("Failed to fetch dynamically imported module")
  );
}

/** Сброс SW — не чаще раза в 2 минуты, иначе шторм перезагрузок кладёт сервер. */
export async function resetServiceWorkers() {
  if (!("serviceWorker" in navigator)) return false;

  const last = Number(sessionStorage.getItem(SW_RESET_KEY) || 0);
  if (Date.now() - last < 120_000) return false;

  sessionStorage.setItem(SW_RESET_KEY, String(Date.now()));
  const regs = await navigator.serviceWorker.getRegistrations();
  await Promise.all(regs.map((r) => r.unregister()));
  window.location.reload();
  return true;
}

/** После деплоя PWA может подхватить старый main.js — один раз перезагружаем страницу. */
export function installPwaRecoveryHandlers() {
  if (typeof window === "undefined") return;

  const reloadOnce = () => {
    if (sessionStorage.getItem(CHUNK_RELOAD_KEY) === "1") return;
    sessionStorage.setItem(CHUNK_RELOAD_KEY, "1");
    window.location.reload();
  };

  window.addEventListener("unhandledrejection", (event) => {
    const msg = String(event.reason?.message || event.reason || "");
    if (isChunkLoadError(event.reason)) {
      reloadOnce();
      return;
    }
    if (msg.includes("respondWith") && msg.includes("null")) {
      event.preventDefault?.();
      resetServiceWorkers();
    }
  });

  window.addEventListener(
    "error",
    (event) => {
      const msg = String(event.message || "");
      if (msg.includes("respondWith") && msg.includes("null")) {
        resetServiceWorkers();
        return;
      }
      const target = event.target;
      if (
        target &&
        (target.tagName === "SCRIPT" || target.tagName === "LINK") &&
        target.src
      ) {
        reloadOnce();
      }
    },
    true,
  );
}
